import { Box } from "@mui/material";
import CustomTabPanel from "../../components/layout/customTabPanel/customTabPanel";
import NewsList from "./components/newsList";

export default function NewsPage() {
  return (
    <Box sx={{ width: "100%" }}>
      <Box sx={{ borderBottom: 1, borderColor: "divider", pt: 2 }}>
        <NewsList />
      </Box>
      <CustomTabPanel value={0} index={0}></CustomTabPanel>
    </Box>
  );
}
